// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"193":"14e35739bce7dc0f04a1","232":"2ab067f9d5ab0435331c","344":"b3fe2555665a33b68c6e","735":"49fbdf450cba40c25ed3","945":"0efe4c56196bb6de6935"}[chunkId] + ".js";
};